import DynamicModuleLoader from "./global/DynamicModuleLoader"
import Config from "./global/Config"
import SimpleBar from "simplebar"

class Main {
	constructor() {
		this.introductionData = {}
		this.fetchData()
		this.dynamicLoad()

		new SimpleBar(document.querySelector(".bb-scene"), { autoHide: false })
	}

	/**
	 * Fetches data from a server and updates the `introductionData` property with the fetched data.
	 *
	 * This function uses the `fetch` API to retrieve data from the path defined in `Config.dataPath`.
	 * If the request is successful, the data is parsed as JSON and the `introduction` property is assigned
	 * to `this.introductionData`.
	 * In case of an error during the fetch request, the error is logged to the console.
	 *
	 * @returns {void} This function does not return any value.
	 */
	fetchData() {
		fetch(Config.dataPath)
			.then(response => response.json())
			.then(data => this.introductionData = data.introduction)
			// eslint-disable-next-line no-console
			.catch(error => console.log(error));
	}

	dynamicLoad() {
		const doCompExist = (classname) => !!document.querySelectorAll(classname).length
		DynamicModuleLoader.load(
			doCompExist(".bb-scene"),
			DynamicModuleLoader.modules.Scene,
			(Component) => {
				document.querySelectorAll(".bb-scene").forEach((item) => {
					new Component(item)
				})
			},
		)

		DynamicModuleLoader.load(
			doCompExist(".login"),
			DynamicModuleLoader.modules.Login,
			(Component) => {
				document.querySelectorAll(".login").forEach((item) => {
					new Component(item)
				})
			},
		)

		DynamicModuleLoader.load(
			doCompExist(".introduction"),
			DynamicModuleLoader.modules.Introduction,
			(Component) => {
				document.querySelectorAll(".introduction").forEach((item) => {
					new Component(item, this.introductionData)
				})
			},
		)

		DynamicModuleLoader.load(
			doCompExist(".checklist"),
			DynamicModuleLoader.modules.Checklist,
			(Component) => {
				document.querySelectorAll(".checklist").forEach((item) => {
					new Component(item)
				})
			},
		)

		DynamicModuleLoader.load(
			doCompExist(".thank-you"),
			DynamicModuleLoader.modules.ThankYou,
			(Component) => {
				document.querySelectorAll(".thank-you").forEach((item) => {
					new Component(item)
				})
			},
		)
	}
}

window.addEventListener(
	"load",
	() => {
		new Main()
	},
	false,
)
